import Vue from 'vue'
import NdInput from './nd-input'
import NdSelect from './nd-select'
import NdChoose from './nd-choose'
import NdAddress from './nd-address'
import Navigation from './navigation'
import NdIndicator from './nd-indicator'
import PageLoading from './page-loading'
import NdSendCode from './nd-send-code'
import NdButton from './nd-button'
import NdCell from './nd-cell'
import NdTabber from './nd-tabbar'
import NdDialog from './nd-dialog'
import NdKeyboard from './nd-keyboard'
import PullDownPage from './pulldown-page'
import { PullRefresh, Icon } from 'vant'
import Mask from './nd-mask'
import Toast from './nd-toast'
import NdItem from './nd-item'
import withdrawMao from './withdraw-mao'
import withdrawMaoPopup from './withdraw-mao-popup'
import NdNavigation from './nd-navigation'
import NdPulldown from './nd-pulldown'
import NdUpload from './nd-upload'
import NdPdf from './nd-pdf'
import ndFollow from './nd-follow'
import IosDownload from '@/components/ios-download'
import VersionTips from './version-tips'
import BackHomeDrag from './back-home-drag'



Vue.use(PullRefresh)
Vue.use(NdIndicator)
Vue.use(PageLoading)
Vue.component('nd-follow', ndFollow)
Vue.component('nd-input', NdInput)
Vue.component('navigation', Navigation)
Vue.component('nd-send-code', NdSendCode)
Vue.component('nd-button', NdButton)
Vue.component('nd-cell', NdCell)
Vue.component('nd-tabbar', NdTabber)
Vue.component('nd-dialog', NdDialog)
Vue.component('pulldown-page', PullDownPage)
Vue.component('nd-select', NdSelect)
Vue.component('nd-choose', NdChoose)
Vue.component('nd-address', NdAddress)
Vue.component('nd-keyboard', NdKeyboard)
Vue.component('nd-item', NdItem)
Vue.component('withdraw-mao', withdrawMao)
Vue.component('withdraw-mao-popup', withdrawMaoPopup)
Vue.component('nd-navigation', NdNavigation)
Vue.component('nd-pulldown', NdPulldown)
Vue.component('nd-upload', NdUpload)
Vue.component('nd-pdf', NdPdf)
Vue.component('ios-download', IosDownload)
Vue.component('version-tips', VersionTips)
Vue.component('back-home-drag', BackHomeDrag)
Vue.component(Icon.name, Icon)
Vue.prototype.$message = Toast
Vue.prototype.$mask = Mask
